import { render } from "./App.vue?vue&type=template&id=224386a2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=224386a2&lang=css"

import exportComponent from "C:\\Users\\griff\\source\\repos\\Owen Associates\\Owen Associates\\Owen_Interiors\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__